module.exports = __webpack_public_path__ + "media/images/no-img-placeholder-ca87eb8c850bc22a9e9baf6a78f7bac7.png";